function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import map from 'lodash/map';
import times from 'lodash/times';
import isEmpty from 'lodash/isEmpty';
import { AppContext } from 'context';
import Pagination from 'components/Pagination';
import App from 'modules/App';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import organizationLogoStyles from '../../OrganizationLogo.pcss';
import Filters from './Filters';
import JoinModal from './JoinModal';
import OrganizationBox from './OrganizationBox';
import styles from './Join.pcss';
var _React_PureComponent;
class Join extends (_React_PureComponent = React.PureComponent) {
    componentDidMount() {
        this.onFetchOrganizations();
    }
    componentDidUpdate(prevProps, prevState) {
        const { isJoinInProgress, hasJoinErrors } = this.props;
        const { queryParams } = this.state;
        if (queryParams !== prevState.queryParams || prevProps.isJoinInProgress !== isJoinInProgress && !isJoinInProgress && !hasJoinErrors) {
            this.onFetchOrganizations();
        }
    }
    onJoinOrganization(chosenOrganizationUID = null) {
        this.setState({
            chosenOrganizationUID
        });
        this.props.onOpenModal();
    }
    onFetchOrganizations() {
        const { queryParams } = this.state;
        this.props.onFetchOrganizations(queryParams);
    }
    onPageChange(page = 0) {
        const start = page * constants.ORGANIZATIONS_PER_PAGE;
        this.setState((state)=>({
                page,
                queryParams: _object_spread_props(_object_spread({}, state.queryParams), {
                    start
                })
            }));
    }
    onSetFilter(filter) {
        const { queryParams } = this.state;
        const newState = {
            page: 0,
            queryParams: _object_spread_props(_object_spread({}, queryParams, filter), {
                start: 0
            })
        };
        if (filter.term) {
            this.setStateDebounce(newState);
            return;
        }
        this.setState(newState);
    }
    renderOrganizationPlaceholders() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.organizations,
            children: times(constants.ORGANIZATIONS_PER_PAGE, (idx)=>/*#__PURE__*/ _jsx(OrganizationBox, {
                    className: "py-3",
                    isPlaceholder: true
                }, idx))
        });
    }
    renderOrganizationList() {
        const { organizations } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.organizations,
            children: map(organizations, (organization)=>/*#__PURE__*/ _jsx(OrganizationBox, {
                    organization: organization,
                    className: "py-3",
                    onJoin: (organizationUID)=>this.onJoinOrganization(organizationUID)
                }, organization.organizationUID))
        });
    }
    renderOrganizations() {
        const { organizations, isFetchInProgress } = this.props;
        if (isFetchInProgress) return this.renderOrganizationPlaceholders();
        if (isEmpty(organizations)) return null;
        return this.renderOrganizationList();
    }
    renderPagination() {
        const { organizationsCount } = this.props;
        const { page } = this.state;
        const totalPages = Math.ceil(organizationsCount / constants.ORGANIZATIONS_PER_PAGE);
        if (totalPages < 2) return null;
        return /*#__PURE__*/ _jsx("div", {
            className: "mt-7",
            children: /*#__PURE__*/ _jsx(Pagination, {
                perPage: constants.ORGANIZATIONS_PER_PAGE,
                onPageChange: (p)=>this.onPageChange(p),
                page: page,
                totalPages: totalPages,
                isPerPageOff: true
            })
        });
    }
    renderContent() {
        const { organizationsCount, isFetchInProgress } = this.props;
        if (!organizationsCount && !isFetchInProgress) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "mt-7",
            children: [
                this.renderOrganizations(),
                this.renderPagination()
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(Filters, {
                    countryCodes: this.props.countryCodes,
                    defaultCountryCode: this.defaultCountryCode,
                    onSetFilter: (filter)=>this.onSetFilter(filter)
                }),
                this.renderContent(),
                /*#__PURE__*/ _jsx(JoinModal, {
                    organizationUID: this.state.chosenOrganizationUID,
                    organizations: this.props.organizations,
                    isInProgress: this.props.isJoinInProgress,
                    hasErrors: this.props.hasJoinErrors
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.setStateDebounce = debounce((state)=>this.setState(state), constants.ORGANIZATION_SEARCH_DEBOUNCE);
        this.defaultCountryCode = get(props.searchFormValues, 'values.countryCode', props.defaultCountryCode);
        this.state = {
            chosenOrganizationUID: null,
            page: 0,
            queryParams: {
                countryCode: this.defaultCountryCode,
                term: '',
                start: 0,
                limit: constants.ORGANIZATIONS_PER_PAGE
            }
        };
    }
}
_define_property(Join, "contextType", AppContext);
_define_property(Join, "propTypes", {
    // Explicit props
    countryCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
    defaultCountryCode: PropTypes.string,
    // Implicit props
    organizations: PropTypes.arrayOf(shapes.organization),
    organizationsCount: PropTypes.number,
    searchFormValues: PropTypes.object,
    isFetchInProgress: PropTypes.bool,
    isJoinInProgress: PropTypes.bool,
    hasJoinErrors: PropTypes.bool,
    // Implicit actions
    onFetchOrganizations: PropTypes.func,
    onOpenModal: PropTypes.func
});
const mapStateToProps = (state)=>({
        organizations: selectors.organizations(state),
        organizationsCount: selectors.organizationsCount(state),
        isFetchInProgress: selectors.isFetchOrganizationInProgress(state),
        isJoinInProgress: selectors.isJoinOrganizationInProgress(state),
        hasJoinErrors: selectors.hasJoinOrganizationErrors(state),
        searchFormValues: App.selectors.formSelector(constants.SEARCH_ORGANIZATION_FORM)(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onFetchOrganizations: (queryParams)=>dispatch(actions.fetchOrganizations(queryParams)),
        onOpenModal: ()=>dispatch(App.actions.openModal(constants.JOIN_MODAL))
    });
const ConnectedJoin = connect(mapStateToProps, mapDispatchToProps)(Join);
export default withStyles(styles, organizationLogoStyles)(ConnectedJoin);
